/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeApiRequest } from "../util";
import { MCUsersEdit } from "./icCheck";

export const deleteXSSIConnection = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/xssi-connections/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const deleteOTARConnection = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/otar-connections/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const getXSSIConnectionByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/xssi-connections/${ref}`,
    token,
    org,
  });

export const getOTARConnectionByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/otar-connections/${ref}`,
    token,
    org,
  });

export const updateOTARConnectionByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/otar-connections/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const getMCPTTUserByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/mc-users/${ref}`,
    token,
    org,
  });

export const updateMCPTTUserByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> => {
  const parsedBody = JSON.parse(body);
  delete parsedBody["DISPLAY-NAME"];
  delete parsedBody["MUTUAL-AID"];
  await MCUsersEdit({
    data: JSON.stringify(parsedBody),
    token,
    org,
  });

  return makeApiRequest<{ Ref: string }>({
    path: `/api/v1/mc-users/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });
};

export const deleteMCPTTUser = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/mc-users/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const getMCPTTGroupByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/mc-groups/${ref}`,
    token,
    org,
  });

export const getMCPTTGroupProfileByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/mc-groups/profile/${ref}`,
    token,
    org,
  });

export const getMCPTTGroupDetailsByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  Promise.allSettled([
    getMCPTTGroupByRef({
      ref,
      org,
      token,
    }),
    getMCPTTGroupProfileByRef({
      ref,
      org,
      token,
    }),
  ]);

export const getLMRUserByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/lmr-users/${ref}`,
    token,
    org,
  });

export const updateLMRUserByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> => {
  return makeApiRequest<{ Ref: string }>({
    path: `/api/v1/lmr-users/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });
};

export const deleteLMRUser = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/lmr-users/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const getLMRGroupByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/lmr-groups/${ref}`,
    token,
    org,
  });

export const getLMRGroupProfileByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/lmr-groups/profile/${ref}`,
    token,
    org,
  });

export const getLMRGroupDetailsByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  Promise.allSettled([
    getLMRGroupByRef({
      ref,
      org,
      token,
    }),
    getLMRGroupProfileByRef({
      ref,
      org,
      token,
    }),
  ]);

export const deleteLMRGroup = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/lmr-groups/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const updateLMRGroupByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> => {
  return makeApiRequest<{ Ref: string }>({
    path: `/api/v1/lmr-groups/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });
};

export const updateLMRGroupProfileByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/lmr-groups/profile/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const getCannedMessageByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/lmr-msgs/${ref}`,
    token,
    org,
  });

export const updateCannedMessageByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/lmr-msgs/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const deleteCannedMessage = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/lmr-msgs/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

// to fetch Org Profile Details
export const getOrganizationProfileByRef = async ({
  token,
  orgID,
}: {
  orgID: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/profile/${orgID}`,
    token,
  });

// to fetch Org Details
export const getOrganizationByRef = async ({
  token,
  orgID,
}: {
  orgID: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/organisations/${orgID}`,
    token,
  });

// to fetch Org and Org Profile Details
export const getOrganizationandProfileDetailsByRef = async ({
  token,
  orgID,
}: {
  orgID: string;
  ref: string;
  token: string;
}): Promise<any> => {
  const data = await Promise.allSettled([
    getOrganizationByRef({ orgID, token }),
    getOrganizationProfileByRef({ orgID, token }),
  ]);
  return data;
};

export const deleteOrganization = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/organisations/${ref}`,
    method: "DELETE",
    token,
    emptyResponse: true,
  });

export const updateOrganizationByRef = async ({
  ref,
  token,
  body,
}: {
  ref: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/organisations/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
  });

export const updateOrganizationProfileByOrgID = async ({
  ref,
  token,
  body,
}: {
  ref: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/profile/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
  });

export const getInstanceByRef = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/instances/${ref}`,
    token,
  });

export const getFaultByRef = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/faults/${ref}`,
    token,
  });

export const getInventoryByRef = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/inventory/${ref}`,
    token,
  });

export const deleteLocation = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/locations/${ref}`,
    method: "DELETE",
    token,
    emptyResponse: true,
  });

export const getLocationByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/locations/${ref}`,
    token,
    org,
  });

export const getDFSIConnectionByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/dfsi-connections/${ref}`,
    token,
    org,
  });

export const getDFSIGroupByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/dfsi-groups/${ref}`,
    token,
    org,
  });

export const getDFSIChannelByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/dfsi-channels/${ref}`,
    token,
    org,
  });

export const updateLocationByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/locations/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const updateDFSIConnectionByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/dfsi-connections/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const updateDFSIGroupByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/dfsi-groups/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const updateDFSIChannelByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/dfsi-channels/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const deleteDFSIConnection = async ({
  ref,
  token,
  org,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/dfsi-connections/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const deleteDFSIChannel = async ({
  ref,
  token,
  org,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/dfsi-channels/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const deleteDFSIGroup = async ({
  ref,
  token,
  org,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/dfsi-groups/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const deleteOrganizationMapping = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/mappings/${ref}`,
    method: "DELETE",
    token,
    emptyResponse: true,
  });

export const getOrganizationMappingByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/mappings/${ref}`,
    token,
    org,
  });

export const updateOrganizationMappingByRef = async ({
  ref,
  token,
  body,
}: {
  ref: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/mappings/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
  });

export const getHistoricalAlarmByRef = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/alarms/historical/${ref}`,
    token,
  });

export const getActiveAlarmByRef = async ({
  ref,
  token,
}: {
  ref: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/alarms/${ref}`,
    token,
  });

export const addActiveAlarmComment = async ({
  ref,
  token,
  content,
}: {
  ref: string;
  token: string;
  content: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/fault-mgmt/alarm/${ref}/comments`,
    token,
    method: "POST",
    emptyResponse: true,
    body: JSON.stringify({
      content,
    }),
  });

export const updateTranslationByRef =
  (type: string) =>
  async ({
    ref,
    org,
    token,
    body,
  }: {
    ref: string;
    org: string;
    token?: string | null;
    body: string;
  }): Promise<any> =>
    makeApiRequest<{ Ref: string }>({
      path: `/api/v1/app-config/translations/${type}/${ref}`,
      method: "PUT",
      body,
      token,
      emptyResponse: true,
      org,
    });

export const deleteTranslation = async ({
  ref,
  org,
  token,
  type,
}: {
  ref: string;
  org: string;
  token: string;
  type: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/translations/${type}/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const getTranslationByRef =
  (type: string) =>
  async ({
    ref,
    token,
    org,
  }: {
    ref: string;
    token: string;
    org: string;
  }): Promise<any> => {
    const response = await makeApiRequest<any[]>({
      path: `/api/v1/app-config/translations/${type}`,
      token,
      org,
    });

    const res = response.filter(({ ID }) => ID === +ref);

    return { ...res[0], type };
  };

export const updateMCPTTGroupByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> => {
  return makeApiRequest<{ Ref: string }>({
    path: `/api/v1/mc-groups/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });
};

export const updateMCPTTGroupProfileByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/mc-groups/profile/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const deleteMCPTTGroup = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/mc-groups/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });

export const getP25UnitDataByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/realtime/p25/ss-reg-unit/${ref}`,
    token,
    org,
  });

export const getP25GroupDataByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/realtime/p25/ss-reg-group/${ref}`,
    token,
    org,
  });

export const getFixedNetworkElementDataByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/realtime/p25/ss-reg-fne/${ref}`,
    token,
    org,
  });

export const getP25AffiliationDataByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  token: string;
  org: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/realtime/p25/group-aff/${ref}`,
    token,
    org,
  });

export const getIKIConnectionByRef = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/iki-connections/${ref}`,
    token,
    org,
  });

export const getIWFCertificate = async ({
  org,
  token,
}: {
  org: string;
  token: string;
}): Promise<any> =>
  makeApiRequest<any>({
    path: `/api/v1/app-config/iki-connections?IKI-NAME=IWF&CONNECTION-ID=Connection-IWF`,
    token,
    org,
  });

export const updateIKIConnectionByRef = async ({
  ref,
  org,
  token,
  body,
}: {
  ref: string;
  org: string;
  token?: string | null;
  body: string;
}): Promise<any> =>
  makeApiRequest<{ Ref: string }>({
    path: `/api/v1/app-config/iki-connections/${ref}`,
    method: "PUT",
    body,
    token,
    emptyResponse: true,
    org,
  });

export const deleteIKIConnection = async ({
  ref,
  org,
  token,
}: {
  ref: string;
  org: string;
  token: string;
}): Promise<unknown> =>
  makeApiRequest<unknown>({
    path: `/api/v1/app-config/iki-connections/${ref}`,
    method: "DELETE",
    token,
    org,
    emptyResponse: true,
  });
